import { useTransition, animated } from 'react-spring'
import styled from 'styled-components'
import { useRef, useState, useEffect } from 'react'

const AppearingElement = ({
  show,
  children,
  maxHeight,
}: {
  show: boolean
  children: React.ReactNode
  maxHeight?: number
}) => {
  const [height, setHeight] = useState<number | null>(null)
  const [allowMaxHeight, setAllowMaxHeight] = useState<boolean>(true)
  const containerRef = useRef<HTMLDivElement>(null)
  const transition = useTransition(show, {
    from: { maxHeight: 0 },
    enter: { maxHeight: height || maxHeight },
    leave: { maxHeight: 0 },
    onProps: () => {
      // console.log('onProps')
      setAllowMaxHeight(true)
    },
    onResolve: () => {
      // console.log('onResolve')
    },
    onRest: () => {
      setAllowMaxHeight(false)
      if (containerRef.current && show) {
        setHeight(containerRef.current.getBoundingClientRect().height)
      }
    },
  })

  useEffect(() => {
    // if (containerRef.current) {
    //   setHeight(containerRef.current.getBoundingClientRect().height)
    // }
  }, [show])

  return transition(
    (style, show) =>
      show && (
        <Container
          ref={containerRef}
          style={{ maxHeight: allowMaxHeight ? style.maxHeight : 'none', overflow: allowMaxHeight ? 'hidden' : 'visible' }}
        >
          {children}
        </Container>
      )
  )
}

const Container = styled(animated.div)`
`

export default AppearingElement
